import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { AppShellComponent } from './core/components/app-shell/app-shell.component';
import { LoginComponent } from './features/auth/login.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { authGuard } from './core/guards/auth.guard';

// Exported so `app-routing.module.spec.ts` can drive `RouterTestingModule`
// against the real route config (not a hand-copied duplicate that could
// drift from it).
export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    component: AppShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      {
        path: 'home',
        loadChildren: () =>
          import('./features/home/home.module').then(m => m.HomeModule),
      },
      {
        path: 'plan',
        loadChildren: () =>
          import('./features/plan/plan.module').then(m => m.PlanModule),
      },
    ],
  },
  // Unknown in-app paths render an in-app 404 instead of falling through to
  // LoginComponent (which used to sit here via `redirectTo: 'login'` and
  // unconditionally hard-bounced to the external QA login host — see
  // NotFoundComponent's doc comment). Auth-guard redirects for protected
  // paths (the `''` branch above) are untouched by this — they only ever
  // match here on genuinely unmatched paths. Must stay LAST.
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      // Download lazy chunks (e.g. the plan module) in the background right after
      // boot, so the first CTA click navigates instantly instead of triggering a
      // click-time chunk fetch that can fail on qastg's cold cache.
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
